// extracted by mini-css-extract-plugin
module.exports = {"selectToRemoveCheck":"SelectRowToDelete_selectToRemoveCheck__2PVQA","remove":"SelectRowToDelete_remove__1NXa8"};